// PR 56 review (22-Oct) · R56-1 the "Reversal of <voucher>" tag; R56-3 the assertion headers of the vouching sheet. EN + AR.
// Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_R56 = {
  en: {
    r56: {
      reversalOf: "Reversal of {voucher}",
      reversalTitle: "This general ledger line carries the opposite sign to an earlier line on the same account with the same voucher (or its narration names the voucher it reverses). Its difference counts against the document as minus the amount.",
      // the display labels only — the stored assertion keys stay as they are
      assertions: {
        occurrence: "Occurrence", completenessTx: "Completeness", accuracy: "Accuracy", cutOff: "Cut-off",
        classificationTx: "Classification", presentationTx: "Presentation", existence: "Existence",
        rights: "Rights and Obligations", completenessBal: "Completeness", avva: "Accuracy, Valuation and Allocation",
        classificationBal: "Classification", presentationBal: "Presentation",
        tx: "(Tx)", bal: "(Bal)",
      },
      naBalance: "Not applicable — this row is a balance-sheet account",
      naPnl: "Not applicable — this row is a P&L account",
    },
  },
  ar: {
    r56: {
      reversalOf: "قيد عكسي لـ {voucher}",
      reversalTitle: "يحمل سطر دفتر الأستاذ العام هذا إشارة معاكسة لسطر سابق على الحساب نفسه وبرقم القيد نفسه (أو يذكر بيانه رقم القيد الذي يعكسه). يُحتسب فرقه مقابل المستند بسالب المبلغ.",
      assertions: {
        occurrence: "الحدوث", completenessTx: "الاكتمال", accuracy: "الدقة", cutOff: "فصل الفترات",
        classificationTx: "التصنيف", presentationTx: "العرض", existence: "الوجود",
        rights: "الحقوق والالتزامات", completenessBal: "الاكتمال", avva: "الدقة والتقييم والتخصيص",
        classificationBal: "التصنيف", presentationBal: "العرض",
        tx: "(المعاملات)", bal: "(الأرصدة)",
      },
      naBalance: "لا ينطبق — هذا الصف حساب في قائمة المركز المالي",
      naPnl: "لا ينطبق — هذا الصف حساب في قائمة الربح أو الخسارة",
    },
  },
};

export default I18N_R56;
